import React, {
  ComponentPropsWithoutRef,
  ComponentType,
  FunctionComponent,
} from 'react';
import { FormattedMessage } from 'react-intl';

import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';

import {
  Badge,
  Description,
  NewBadge,
  Spacer,
  Subtitle,
  TextWrapper,
  TileWrapper,
  Title,
} from './styled';

interface Props extends ComponentPropsWithoutRef<'a'> {
  subtitle?: string;
  title: string;
  description: string;
  background: IGatsbyImageData;
  exclusive?: boolean; // lounge sneak peek
  comingSoon?: boolean; // not lounge coming soon
  label?: 'new' | 'limited';
  as?: string | ComponentType<any> | undefined;
}

const ImageTile: FunctionComponent<Props> = ({
  subtitle,
  title,
  description,
  background,
  exclusive,
  comingSoon,
  as,
  label,
  ...rest
}) => {
  return (
    <TileWrapper as={as} {...rest}>
      <GatsbyImage
        image={background}
        alt={title}
        style={{
          position: 'absolute',
          maxHeight: '160px',
          zIndex: -1,
          borderRadius: '12px',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          cursor: exclusive || comingSoon ? 'default' : 'pointer',
          filter: exclusive ? 'blur(10px)' : 'unset',
        }}
      />
      <TextWrapper>
        {background && <Spacer />}
        {subtitle && <Subtitle exclusive={exclusive}>{subtitle}</Subtitle>}
        <Title>{title}</Title>
        <Description>{description}</Description>
      </TextWrapper>
      {(exclusive || comingSoon) && (
        <Badge>
          <FormattedMessage id="global.labels.comingSoon" />
        </Badge>
      )}
      {label && (
        <NewBadge>
          <FormattedMessage id={`home.labels.${label}`} />
        </NewBadge>
      )}
    </TileWrapper>
  );
};

export default ImageTile;
